import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  logo,
  section2partnership,
  OnlineBookingSystemIcon,
  wilsonLogo,
  underArmourLogo,
  NSCALogo,
  TeamSnapLogo,
  sklzLogo,
  Analytics,
  StarIconRed,
  ChatIconRed,
  AthleteImg,
  jsonNgoProfile,
  leeChenProfile,
  yeLinProfile,
  jsonProfile,
  vincentProfile,
  whatOurPartnerSay,
  partnerSayingLogo,
  arrowImage,
  HeadingBg,
  rightArrow1,
  rightArrow2,
  ArrowUpRightWhite,
  SchoolImg,
  ClubPartnershipsImg,
} from "../../../constant/imagePath";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import { PartnershipProgramCard } from "../../../stories/PartnershipProgramCard/PartnershipProgramCard";
import { UnsortedStep } from "../../../stories/UnsortedStep1/UnsortedStep";
import { Footer } from "../../../stories/Footer/Footer";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Button } from "../../../stories/Button/Button";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader";

import css from "./Partnership.module.css";
import { PlayCard } from "../../../stories/PlayCard/PlayCard";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import { MobilePartnershipProgramCard } from "../../../stories/MobilePartnershipProgramCard/MobilePartnershipProgramCard";
import PartnershipMobile from "./PartnershipMobile";

const demoData = [
  {
    logo: wilsonLogo,
  },
  {
    logo: underArmourLogo,
  },
  {
    logo: NSCALogo,
  },
  {
    logo: TeamSnapLogo,
  },
  {
    logo: sklzLogo,
  },
];

const demoCardData = [
  {
    stepNo: "1",
    icon: Analytics,
    title: "Let us know about your training goals",
    tagline: "You can browse through all coach profiles and sort the results.",
  },
  {
    stepNo: "2",
    icon: StarIconRed,
    title: "Book to start training",
    tagline: "After you book your coach, you'll receive each others contacts.",
  },
  {
    stepNo: "3",
    icon: ChatIconRed,
    title: "Learn new skills, gain confidence",
    tagline: "Remember, you're in good hands with our customer support team.",
  },
];

const partnershipProgramCardData = [
  {
    image: AthleteImg,
    headings: "Athlete",
    description:
      "All of our coaches have extensive coaching experience and are required to pass rigorous background checks.",
  },
  {
    image: SchoolImg,
    headings: "School",
    description:
      "Every coaching session can be booked in minutes through Lytesnap and all financial transactions are securely processed online.",
  },
  {
    image: ClubPartnershipsImg,
    headings: "Club partnerships",
    description:
      "We are committed to helping you find the right coach, and we back that up with our 100% money-back guarantee.",
  },
];

const profileCardData = [
  {
    image: jsonNgoProfile,
    name: "Jason Ngo",
    designation: "CEO and co-founder",
  },
  {
    image: leeChenProfile,
    name: "Lee Chen-Kai",
    designation: "COO",
  },
  {
    image: yeLinProfile,
    name: "Ye Lin",
    designation: "CFO",
  },
  {
    image: jsonProfile,
    name: "Lee Chen-Kai",
    designation: "COO",
  },
  {
    image: vincentProfile,
    name: "Lee Chen-Kai",
    designation: "COO",
  },
];

function PartnershipDesktop() {
  const [isMobile, setIsMobile] = useState(false);
  const [
    activePartnershipProgramCardIndex,
    setActivePartnershipProgramCardIndex,
  ] = useState(0);

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);
  return (
    <div>
      <Container fluid className="p-0">
        <Row className="gx-0">
          {/* First Section Head Container*/}
          <Col md={12}>
            <div className={css.headSection}>
              <AfterLoginHeader
                isWhite
                icon={logo}
                className={`${[css.container].join(" ")}`}
                customStyle={{
                  padding: "0px",
                  paddingTop: "24px",
                }}
                getAMatchIcon={ArrowUpRightWhite}
              />
              <Container className={`p-0 ${[css.container].join(" ")}`}>
                <div className={css.headSectionText}>
                  <Row>
                    <Col md={6}>
                      <p
                        style={{
                          ...Fonts.h1,
                          color: "#ffffff",
                          textTransform: "uppercase",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        Let's work{" "}
                        <span className={css.headingBg}>
                          Together
                          <img src={HeadingBg} alt="" />
                          &nbsp;&nbsp;&nbsp;
                        </span>
                      </p>
                    </Col>

                    <Col md={6}>
                      <div className={css.taglineWithButton}>
                        <p
                          className={css.tagline}
                          style={{
                            color: Colors.white,
                            ...Fonts.p1,
                          }}
                        >
                          Partner with the company that is revolutionizing how
                          athletes and coaches train together.
                        </p>
                        <Button
                          label="Apply Now"
                          size="Large"
                          primary={true}
                          customStyle={{
                            width: "200px",
                            height: "56px",
                            marginTop: "24px",
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Container>
            </div>
          </Col>
          {/* Why partner with Lytesnap? Second Section*/}
          <Col md={12}>
            <div className={css.section2MainContainer}>
              <Container className={`p-0 ${[css.container].join(" ")}`}>
                <Row>
                  <Col md={7}>
                    <div style={{ width: "80%" }}>
                      <div>
                        <img
                          src={OnlineBookingSystemIcon}
                          alt="OnlineBookingSystemIcon"
                        />
                      </div>
                      <p
                        style={{
                          ...Fonts.h2,
                          color: Colors.neutralShadesOfNero,
                          marginTop: "24px",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        Why partner with Lytesnap?
                      </p>
                      <p
                        style={{
                          ...Fonts.p1,
                          fontSize: "14px",
                          marginTop: "24px",
                        }}
                      >
                        Lytesnap is a community where athletes, parents, and
                        coaches go to talk about and share everything they know
                        and love about sports and fitness. Tryout tips, success
                        stories, or the hottest youth sports news - Lytesnap has
                        you covered.
                      </p>
                      <Button
                        label="Apply Now"
                        primary={true}
                        size={"Large"}
                        customStyle={{
                          width: "200px",
                          height: "56px",
                          marginTop: "56px",
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={5}>
                    <div className={css.sec2Image}>
                      <img src={section2partnership} alt="partnership" />
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
          <Col md={12}>
            <Container className={`p-0 ${[css.container].join(" ")}`}>
              <Row className={css.joinOurHigh}>
                <Col md={6}>
                  <p
                    style={{
                      ...Fonts.h3,
                      color: Colors.neutralShadesOfNero,
                    }}
                  >
                    Join our other high-growth partners
                  </p>
                </Col>
                <Col md={12}>
                  <div className={css.companiesLogo}>
                    <ul>
                      {demoData.map((item, index, arr) => {
                        return (
                          <li key={index}>
                            <div>
                              <img src={item?.logo} alt="logo" />
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
          {/* Section 3 Here's how it works */}
          <Col
            md={12}
            style={{ backgroundColor: Colors.neutralShadesOfWhiteSmoke }}
            className={css.section3MainContainer}
          >
            <Container className={`p-0 ${[css.container].join(" ")}`}>
              <Col md={12} className={css.section3Heading}>
                <h1
                  style={{
                    ...Fonts.h2,
                    color: Colors.neutralShadesOfNero,
                    letterSpacing: "-0.5px",
                  }}
                >
                  Here's how it{" "}
                  <span className={css.headingBg}>
                    works
                    <img src={HeadingBg} alt="" />
                    &nbsp; &nbsp;
                  </span>
                </h1>
              </Col>
              <Row className={css.cardContainer}>
                {demoCardData.map((item, index, arr) => {
                  return (
                    <Col md={4} key={index}>
                      <div className={css.cardInnerContainer}>
                        {arr.length - 1 === index ? (
                          ""
                        ) : (
                          <img
                            src={index % 2 === 0 ? rightArrow2 : rightArrow1}
                            alt=""
                            className={css.cardInnerContainerImg}
                          />
                        )}
                        <UnsortedStep data={item} />
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Container>
          </Col>
          {/* Section 4 Who the partnership program is for? */}
          <Col md={12}>
            <Container className={`p-0 ${[css.container, css.sec4].join(" ")}`}>
              <Col md={8}>
                <h2 style={{ ...Fonts.h2, letterSpacing: "-0.5px" }}>
                  Who the
                  <span className={css.headingBg}>
                    &nbsp;partnership&nbsp;&nbsp;
                    <img src={HeadingBg} alt="" />
                  </span>
                  program is for?
                </h2>
              </Col>
              <Col md={12} className={css.partnershipProgramCard}>
                {partnershipProgramCardData.map((item, index) => {
                  return (
                    <div
                      style={{
                        marginBottom:
                          index < partnershipProgramCardData.length - 1
                            ? "40px"
                            : "0px",
                      }}
                    >
                      <PartnershipProgramCard
                        image={item?.image}
                        heading={item?.headings}
                        description={item?.description}
                        onClick={() => {
                          setActivePartnershipProgramCardIndex(index);
                        }}
                        isActive={index == activePartnershipProgramCardIndex}
                      />
                    </div>
                  );
                })}
              </Col>
            </Container>
          </Col>
          {/* Section 5 Get to know us */}
          <Col md={12}>
            <Container
              className={`p-0 ${[
                css.container,
                css.sec5marginMainContainer,
              ].join(" ")}`}
            >
              <Col md={12} className={css.sec5Heading}>
                <h1 style={{ ...Fonts.h2 }}>
                  Get to
                  <span className={css.headingBg}>
                    &nbsp;&nbsp;know us&nbsp; &nbsp;
                    <img src={HeadingBg} alt="" />
                  </span>
                </h1>
              </Col>
              <Col md={12}>
                <div className={`${[css.cardsContainer].join(" ")}`}>
                  {profileCardData.map((item, index) => {
                    return (
                      <PlayCard
                        icon={item.image}
                        title={item.name}
                        value={item.designation}
                        customStyle={{ width: "156px" }}
                        iconStyle={{ width: "156px", height: "156px" }}
                        titleStyle={{
                          textAlign: "center",
                          width: "100%",
                          marginTop: "24px",
                          ...Fonts.h5,
                          color: Colors.neutralShadesOfNero,
                        }}
                        valueStyle={{
                          width: "100%",
                          marginTop: "8px",
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfDimGray,
                        }}
                      />
                    );
                  })}
                </div>
              </Col>
            </Container>
          </Col>
          {/* Section 6 What our partners are saying */}
          <Col md={12}>
            <div className={css.section6MainContainer}>
              <Container className={`p-0 ${[css.container].join(" ")}`}>
                <Col md={7} className={css.section6Heading}>
                  <h1
                    style={{
                      ...Fonts.h2,
                      width: "590px",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    What our partners are saying
                  </h1>
                </Col>
                <Row className={css.section6Body}>
                  <Col md={6}>
                    <div className={css.section6Image}>
                      <img src={whatOurPartnerSay} alt="" />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div style={{ marginLeft: "70px" }}>
                      <p
                        style={{
                          ...Fonts.h5,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        “I am very fond of the idea of CoachUp and enthusiastic
                        about it. Anytime you can have extra training, guidance,
                        and help in something that you enjoy doing, and in which
                        you have shown the capacity and desire to improve.”
                      </p>
                      <div className={css.section6logoWithTitle}>
                        <div>
                          <img src={partnerSayingLogo} alt="" />
                        </div>
                        <div className={css.section6NameAndDesignation}>
                          <p
                            style={{
                              ...Fonts.h5,
                              color: Colors.neutralShadesOfNero,
                            }}
                          >
                            Truman So
                          </p>
                          <p
                            style={{
                              ...Fonts.p1,
                              color: Colors.neutralShadesOfNero,
                            }}
                          >
                            Technology Partnerships Lead at Under Armour
                          </p>
                        </div>
                      </div>
                      <div className={css.section6ApplyNowButton}>
                        <Button
                          primary={true}
                          size="Large"
                          label="Apply Now"
                          customStyle={
                            isMobile
                              ? { width: "100%", height: "56px" }
                              : { width: "200px", height: "56px" }
                          }
                        />
                      </div>
                      {isMobile ? (
                        ""
                      ) : (
                        <div className={css.sec6arrow}>
                          <img src={arrowImage} alt="" />
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
          <Col md={12}>
            <Footer className={css.container} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

function Partnership() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <PartnershipMobile /> : <PartnershipDesktop />;
}

export default Partnership;
